import React from 'react';
import Input from '../../../components/ui/Input';
import { parseGoogleDriveFolderId } from '../constants';
import GoogleDriveConnectPanel from './GoogleDriveConnectPanel';
import GoogleDriveFolderPicker from './GoogleDriveFolderPicker';

function GoogleDriveSourceFields({
  values,
  driveRefreshKey,
  googleDriveInfo,
  oauthConfigured,
  workspaceMode,
  onWorkspaceModeChange,
  driveConnected,
  onDriveStatusChange,
  onFieldChange,
  onFolderUrlChange,
  onFolderPickerChange,
}) {
  const hasDriveFolder =
    Boolean(values.folderId?.trim()) ||
    Boolean(parseGoogleDriveFolderId(values.folderUrl));

  const showPickerAndUrl = workspaceMode || driveConnected;

  return (
    <div className="space-y-4 rounded-xl border border-surface-border bg-slate-50/60 p-4">
      {!workspaceMode && (
        <GoogleDriveConnectPanel
          compact
          refreshKey={driveRefreshKey}
          oauthConfigured={oauthConfigured}
          instructions={googleDriveInfo?.instructions}
          onStatusChange={onDriveStatusChange}
        />
      )}

      {showPickerAndUrl && (
        <>
          {!workspaceMode && driveConnected && (
            <GoogleDriveFolderPicker
              connected={driveConnected}
              value={{
                folderId: values.folderId,
                folderName: values.folderName,
                folderUrl: values.folderUrl,
              }}
              onChange={onFolderPickerChange}
            />
          )}

          {!workspaceMode && driveConnected && (
            <div className="relative flex items-center py-0.5">
              <div className="flex-grow border-t border-surface-border" />
              <span className="mx-3 text-xs text-content-muted shrink-0">
                ou cole o link da pasta
              </span>
              <div className="flex-grow border-t border-surface-border" />
            </div>
          )}

          <Input
            id="kb_drive_url"
            label="Link da pasta"
            type="url"
            value={values.folderUrl}
            onChange={onFolderUrlChange}
            placeholder="https://drive.google.com/drive/folders/..."
            required={!hasDriveFolder}
            hint={
              !workspaceMode && driveConnected
                ? 'Opcional se você já selecionou uma pasta acima, ou use só o link.'
                : undefined
            }
          />
        </>
      )}

      <details
        className="text-sm"
        open={workspaceMode}
        onToggle={(event) => onWorkspaceModeChange(event.target.open)}
      >
        <summary className="cursor-pointer text-forge-600 hover:text-forge-700 select-none">
          Opções avançadas (Google Workspace)
        </summary>
        <div className="mt-3 space-y-3 rounded-lg border border-amber-200 bg-amber-50 p-4">
          <p className="text-xs text-amber-900">
            Modo avançado para Google Workspace com Domain-Wide Delegation configurado pelo
            administrador.
            {googleDriveInfo?.service_account_email && (
              <>
                {' '}
                Service account:{' '}
                <span className="font-mono break-all">
                  {googleDriveInfo.service_account_email}
                </span>
              </>
            )}
          </p>
          <Input
            id="kb_workspace_email"
            label="E-mail Workspace"
            type="email"
            value={values.workspaceEmail}
            onChange={onFieldChange('workspaceEmail')}
            placeholder="usuario@empresa.com"
            required={workspaceMode}
          />
        </div>
      </details>
    </div>
  );
}

export default GoogleDriveSourceFields;
